import _taggedTemplateLiteral from 'babel-runtime/helpers/taggedTemplateLiteral';

var _templateObject = _taggedTemplateLiteral(['\n  &:hover svg path {\n    stroke: ', ';\n    &.tires {\n      fill: ', ';\n      stroke: transparent;\n    }\n  }\n'], ['\n  &:hover svg path {\n    stroke: ', ';\n    &.tires {\n      fill: ', ';\n      stroke: transparent;\n    }\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  position: relative;\n\n  span {\n    background: ', ';\n    border-radius: 50%;\n    color: ', ';\n    display: inline-block;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: -1px;\n    line-height: 17px;\n    position: absolute;\n    right: -12px;\n    text-align: center;\n    top: -5px;\n    width: 17px;\n  }\n'], ['\n  position: relative;\n\n  span {\n    background: ', ';\n    border-radius: 50%;\n    color: ', ';\n    display: inline-block;\n    font-size: 11px;\n    font-weight: 700;\n    letter-spacing: -1px;\n    line-height: 17px;\n    position: absolute;\n    right: -12px;\n    text-align: center;\n    top: -5px;\n    width: 17px;\n  }\n']);

import styled from 'styled-components';

export var StyledButton = styled.button(_templateObject, function (props) {
  return props.theme.dormifyPink;
}, function (props) {
  return props.theme.dormifyPink;
});

export var StyledDiv = styled.div(_templateObject2, function (props) {
  return props.theme.dormifyPink;
}, function (props) {
  return props.theme.dormifyWhite;
});